import { isDefinedArray, isNullOrUndefined, isNumber } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable } from "mobx";

import { apiCallGetMyCSRPrevActions } from "../../../api/csr-api/api-call-get-my-csr-prev-actions";
import { TAuditEvent } from "../../../Types";
import getCorePersonalStore from "../../core/core-personal-store";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class MyCSRPrevActionsStore {
  myPrevActions = observable.box<TAuditEvent[]>([]);
  getMyPrevActions = async () => {
    const adminId = getCorePersonalStore().user.get().id;
    const definedNumber = isNumber(adminId) ? adminId : parseInt(adminId, 10);
    if (!isNumber(definedNumber) || definedNumber === -1) {
      return;
    }

    getCoreUIStore().setIsLoading("CSR_MY_PREV_ACTIONS", true);
    const { data, status, code } = await apiCallGetMyCSRPrevActions({
      adminId: adminId
    });

    getCoreUIStore().setIsLoading("CSR_MY_PREV_ACTIONS", false);
    if (status === "OK") {
      if (!isNullOrUndefined(data) && isDefinedArray(data)) {
        this.myPrevActions.set(data);
      } else {
        this.myPrevActions.set([]);
        getCorePopUpStore().showAlertMessage("EVENTS_NOT_FOUND");
      }
    } else {
      this.myPrevActions.set([]);
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  csrPrevActionsListOrdered = computed(() => {
    const csrList = orderBy(this.myPrevActions.get(), ["created_on"], ["desc"]);
    return csrList;
  });
}

const getMyCSRPrevActionsStore = memoize(
  () => new MyCSRPrevActionsStore(),
  () => 1
);
export default getMyCSRPrevActionsStore;
